var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.programs.length)?_c('div',{staticClass:"crm b-segment"},[_c('toolbar'),_c('widget-line'),_c('app-table')],1):_c('div',[_c('dummy-screen')],1)}
var staticRenderFns = []

export { render, staticRenderFns }